var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',_vm._b({staticClass:"upsell-trigger",on:{"click":_vm.submit}},'ButtonComponent',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }